import { render, staticRenderFns } from "./ReferralsViewDetails.vue?vue&type=template&id=2c212c40&scoped=true"
import script from "./ReferralsViewDetails.vue?vue&type=script&lang=js"
export * from "./ReferralsViewDetails.vue?vue&type=script&lang=js"
import style0 from "./ReferralsViewDetails.vue?vue&type=style&index=0&id=2c212c40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c212c40",
  null
  
)

export default component.exports